import { t } from '@avalara/bat-apps-shared/i18n';
import type { Content } from '../../../../types';
import type { AccordionContent } from '../shared/accordion-root';

export const riskBannerText = {
  heading: 'Avalara Professional Services',
  subHeading1: 'SALES TAX RISK ASSESSMENT',
  subHeading2:
    'Figuring out on your own where you owe sales tax can be complicated and risky. Guidance from our team of experts makes it easier.',
  infoHeading: "What's included:",
  infoBullet1: 'Guided nexus questionnaire you can complete at your own pace',
  infoBullet2: 'In-depth analysis of economic and physical nexus tax obligations',
  infoBullet3:
    'Quick turnaround: Once we get your questionnaire results, expect our analysis within three business days',
  infoBullet4: 'One-on-one consultation with an Avalara sales tax professional',
};

export const accordionContent: Array<AccordionContent> = [
  {
    title: t('client.headings.guided-nexus-questionnaire'),
    content:
      "When you take Avalara's nexus questionnaire, you give us a comprehensive overview of your business activity. This survey takes some time, and you likely won't complete it in one sitting. However, the more detail you provide about your business, the more accurate our analysis will be.",
  },
  {
    title: t('client.headings.what-our-analysis-covers'),
    content:
      "The Sales Tax Risk Assessment is limited to sales-tax obligations for one business for one year. It can't analyze income tax, taxability, registration, affiliate nexus, or multiple years of activity.",
  },
  {
    title: t('client.headings.full-report-and-consultation'),
    content:
      "After you complete the nexus questionnaire, you'll get our analysis as a detailed report on your sales-tax obligations. We also invite you to set up a personalized consultation to review your results with one of our tax directors.",
  },
  {
    title: t('client.headings.your-data-is-safe-with-us'),
    content: "We'll never report the information you give us on this assessment to a tax authority.",
  },
];

export const emailLinkText: string =
  "In the next few days, we'll email you a link to our nexus questionnaire, an in-depth survey of your business activities";

export const saveTimeText: string =
  'Save time by gathering information about your business before taking the questionnaire:';

export const informationYouNeedBulletContent: Array<string> = [
  "A list of where you're registered to collect and pay tax",
  'Sales data by state for last year and year to date',
  'Information on employee and third-party activities, such as remote work and trade shows',
];

export const content: Array<Content> = [
  {
    title: t('client.headings.see-other-ways-our-tax-pros-can-help'),
    textContent:
      "Avalara's tax experts can advise you on more than just nexus. They can also guide you through business licenses, VDAs, backfiling, and integrating Avalara with your business ecosystem.",
    buttonText: 'Get expert help',
    link: 'https://www.avalara.com/us/en/products/professional-services.html',
  },
  {
    title: t('client.headings.expand-your-sales-tax-knowledge'),
    textContent:
      'From state-specific sales tax guides to interactive tools, our collection of resources can help you better understand your business sales tax and how to automate it.',
    buttonText: 'Visit our resource page',
    link: 'https://www.avalara.com/us/en/learn/sales-tax.html',
  },
  {
    title: t('client.headings.get-sales-tax-compliant'),
    textContent:
      'Automating sales tax calculation, collection, and remittance is the best way to improve sales tax compliance. This is especially important when your business sells in multiple states.',
    buttonText: 'Explore compliance solutions',
    link: 'https://www.avalara.com/us/en/products/sales-and-use-tax/sales-and-use-tax-fp.html',
  },
];
